import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./components/formikComponents/FormikControl";
import axios from "axios";
import Swal from "sweetalert2";

const genderOptions = [
  { id: "man", value: "مرد" },
  { id: "woman", value: "زن" },
  { id: "gozmite", value: "گوزمیت" },
];

const validationSchema = Yup.object({
  fullName: Yup.string().min(3, "نام باید حداقل 3 کاراکتر باشد"),
  // .required("نام الزامی است")
  userName: Yup.string()
    .min(3, "نام کاربری باید حداقل 3 کاراکتر باشد")
    // .required("نام کاربری الزامی است")
    .matches(/^\S*$/, "نام کاربری نباید شامل فاصله باشد")
    .matches(
      /^[a-zA-Z0-9_]+$/,
      "نام کاربری فقط می‌تواند شامل حروف، اعداد انگلیسی و زیرخط باشد"
    ),
  emailAddress: Yup.string().email("آدرس ایمیل معتبر نیست"),
  // .required("ایمیل الزامی است")
  phone: Yup.number()
    .typeError("لطفاً فقط عدد وارد کنید!")
    .required("پر کردن این قسمت ضروری است!"),
  password: Yup.string()
    .min(6, "رمز عبور باید حداقل 6 کاراکتر باشد")
    .matches(/^\S*$/, "رمز عبور نباید شامل فاصله باشد")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{6,}$/,
      "رمز عبور باید شامل حداقل یک حرف و یک عدد باشد"
    )
    .matches(
      /^[A-Za-z\d@$!%*#?&]{6,}$/,
      "رمز عبور فقط می‌تواند شامل حروف، اعداد و کاراکترهای خاص @$!%*#?& باشد"
    )
    .required("رمز عبور الزامی است"),
  loginRePassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "تکرار رمز عبور مطابقت ندارد")
    .required("تکرار رمز عبور الزامی است"),
  birthDate: Yup.string(),
  // .required("تاریخ تولد اجباری است!")
  imageFile: Yup.mixed()
    .required("تصویر کاربری الزامی است")
    .test("fileType", "نوع فایل باید jpeg یا png یا jpg باشد!", (value) => {
      if(value === null) return false;
      return ["image/jpeg", "image/jpg", "image/png"].includes(value.type);
    })
    .test(
      "fileSize",
      "اندازه فایل باید کمتر از ۵۰۰ کیلوبایت باشد!",
      (value) => {
        if(value === null) return false;
        return value.size <= 500 * 1024;
      }
    ),
});

const initialValues = {
  fullName: "",
  userName: "",
  emailAddress: "",
  phone: "",
  password: "",
  loginRePassword: "",
  birthDate: "",
  gender: "man",
  imageّFile: null,
};

const onSubmit = (values, actions) => {
  console.log("Form Submitted", values);
  console.log("Actions : ", actions);

  let formData = new FormData();
  formData.append("phone", values.phone);
  formData.append("password", values.password);
 
  axios
    .post("http://authservice.azhadev.ir/api/auth/register", formData)
    .then((response) => {
      console.log("Success:", response.data);
      localStorage.setItem("token", response.data.token);
      actions.setSubmitting(false);
      actions.resetForm();
      Swal.fire({
        title: "<small>ثبت نام با موفقیت انجام شد!</small>",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          popup: "swal-small-popup",
          title: "swal-small-title",
          icon: "swal-small-icon",
        }
      });
      

    })
    .catch((error) => {
      console.error("Error:", error);
      actions.setSubmitting(false);
     Swal.fire({
        title: "<small>خطا در ثبت نام. لطفاً دوباره تلاش کنید.</small>",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          popup: "swal-small-popup",
          title: "swal-small-title",
          icon: "swal-small-icon",
        }
      });
    });
};

const Register = () => {
  const [isloading, setIsloading] = useState(true);

  useEffect(() => {
    document.title = "Register Formik";
    setTimeout(() => setIsloading(false), 1000);
  }, []);

  return (
    <Fragment>
      <div
        className="preloader preloader-dark"
        style={{
          opacity: isloading ? 1 : 0,
          visibility: isloading ? "visible" : "hidden",
          transition: "opacity 0.5s ease, visibility 0.5s ease",
        }}
      >
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div id="main-wrapper" className="oxyy-login-register">
        <div className="hero-wrap min-vh-100">
          <div className="hero-mask opacity-4 bg-secondary"></div>
          <div
            className="hero-bg hero-bg-scroll"
            style={{ backgroundImage: "url('../auth/img/login-bg-5.jpg')" }}
          ></div>
          <div className="hero-content d-flex min-vh-100">
            <div className="container my-auto">
              <div className="row">
                <div className="col-md-9 col-lg-7 col-xl-5 mx-auto">
                  <div className="hero-wrap rounded shadow-lg p-4 py-sm-5 px-sm-5 my-4">
                    <div className="hero-mask opacity-9 bg-dark"></div>
                    <div className="hero-content">
                      <div className="logo mb-4">
                        <a
                          className="d-flex justify-content-center"
                          href="index.html"
                          title="Oxyy"
                        >
                          <img src="../auth/img/logo.png" alt="Oxyy Logo" />
                        </a>
                      </div>
                      <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        validateOnChange={true}
                      >
                        {(formik) => (
                          <Form id="registerForm" className="form-dark">
                            <FormikControl
                              control="input"
                              type="text"
                              name="fullName"
                              icon="fas fa-user"
                              formik={formik}
                              placeholder="نام کامل"
                              direction="ltr"
                            />

                            <FormikControl
                              control="input"
                              type="text"
                              name="userName"
                              icon="fas fa-user"
                              formik={formik}
                              placeholder="نام کاربری"
                              direction="ltr"
                            />

                            <FormikControl
                              control="input"
                              type="text"
                              name="emailAddress"
                              icon="fas fa-envelope"
                              formik={formik}
                              placeholder="آدرس ایمیل"
                              direction="ltr"
                            />
                            <FormikControl
                              control="input"
                              type="text"
                              name="phone"
                              icon="fas fa-phone"
                              formik={formik}
                              placeholder="شماره موبایل "
                              direction="ltr"
                            />
                            <FormikControl
                              control="input"
                              type="password"
                              name="password"
                              icon="fas fa-lock"
                              formik={formik}
                              placeholder="رمز عبور"
                              direction="ltr"
                            />
                            <FormikControl
                              control="input"
                              type="password"
                              name="loginRePassword"
                              icon="fas fa-lock"
                              formik={formik}
                              placeholder="تکرار رمز عبور"
                              direction="ltr"
                            />
                            <FormikControl
                              control="date"
                              name="birthDate"
                              icon="fas fa-calendar"
                              formik={formik}
                              placeholder="تاریخ تولد"
                              direction="ltr"
                            />

                            <FormikControl
                              control="radio"
                              name="gender"
                              icon="fas fa-gender"
                              formik={formik}
                              placeholder="جنیست "
                              direction="ltr"
                              options={genderOptions}
                            />

                            <FormikControl
                              control="file"
                              name="imageFile"
                              icon="fas fa-image"
                              formik={formik}
                              placeholder="تصویرکاربری "
                              direction="ltr"
                            />

                            <button
                              className="btn btn-primary btn-block mt-4 mb-3"
                              type="submit"
                            >
                              {formik.isSubmitting ? (
                                <div className="spinner-border" role="status">
                                  <span className="visually-hidden">
                                    
                                  </span>
                                </div>
                              ) : (
                                "ثبت نام"
                              )}
                            </button>
                            <p className="text-center text-muted text-2 mt-2 mb-0">
                              شما قبول دارید
                              <a className="btn-link text-light" href="#">
                                قوانین
                              </a>{" "}
                              و{" "}
                              <a className="btn-link text-light" href="#">
                                سیاست حریم خصوصی
                              </a>
                            </p>
                          </Form>
                        )}
                      </Formik>
                      <div className="d-flex align-items-center mt-2 mb-3">
                        <hr className="flex-grow-1 border-dark" />
                        
                      </div>
                     
                      <p className="text-2 text-muted text-center mb-0">
                        حساب کاربری دارید؟{" "}
                        <Link className="btn-link text-light text-3" to="/">
                          وارد شدن
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Register;
